import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon } from 'design-react-kit';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

class RiassegnaAfferentiToolbar extends Component {
    hasPermissions() {
        const { actions } = this.props;
        return actions?.user?.some((ua) => ua?.id === 'toolbar-riassegna-afferenti');
    }

    getCurrentPath() {
        const { breadcrumbs } = this.props;
        return breadcrumbs.length > 0
            ? breadcrumbs[breadcrumbs.length - 1]?.url
            : '/';
    }

    render() {
        if (!this.hasPermissions()) return null;

        const { intl } = this.props;
        const toolbar_title = intl.formatMessage({ id: 'riassegna_afferenti' });
        const currentPath = this.getCurrentPath();

        return (
            <Plug pluggable="main.toolbar.top" id="riassegna-afferenti-toolbar">
                <Link
                    // to="/riassegna-afferenti"
                    to={`/controlpanel/UnibaRiassegnaAfferentiEditForm?strutturaAfferenza_partenza=${encodeURIComponent(currentPath)}`}
                    aria-label={toolbar_title}
                    tabIndex={0}
                    className="deleteBlocks"
                    id="toolbar-riassegna-afferenti"
                >
                    <Icon 
                        icon="it-piattaforme" 
                        color="secondary" 
                        size="md" 
                        title={toolbar_title} 
                        alt={toolbar_title} 
                    />
                </Link>
            </Plug>
        )
    }
}

const mapStateToProps = (state) => ({
    actions: state?.actions?.actions,
    breadcrumbs: state.breadcrumbs.items || [],
});

export default injectLazyLibs(['toastify'])(
    connect(
        mapStateToProps
    )
        (injectIntl(
            RiassegnaAfferentiToolbar
        ))
);
